import { defineComponent as w, computed as g, ref as L, openBlock as r, createElementBlock as b, createBlock as m, createCommentVNode as h, createVNode as k, Fragment as y, renderList as B } from "vue";
import F from "./index53.js";
import o from "./index52.js";
const E = {
  class: "flex min-h-8 w-fit flex-row items-center justify-center gap-2 p-0",
  "data-name": "Pagination"
}, S = /* @__PURE__ */ w({
  __name: "BasePagination",
  props: {
    currentPage: {},
    totalPages: {},
    maxVisiblePages: {},
    showFirstLast: { type: Boolean, default: !1 }
  },
  emits: ["pageChange"],
  setup(u, { emit: x }) {
    const e = u, C = x, l = (t) => {
      t >= 1 && t <= e.totalPages && t !== e.currentPage && C("pageChange", t);
    }, f = (t) => {
      l(t === "left" ? e.currentPage - 1 : e.currentPage + 1);
    }, P = g(() => e.currentPage === 1), v = g(() => e.currentPage === e.totalPages), M = g(() => {
      if (!e.maxVisiblePages) {
        const s = [];
        for (let d = 1; d <= e.totalPages; d++)
          s.push(d);
        return s;
      }
      const t = [], a = Math.floor(e.maxVisiblePages / 2);
      let n = Math.max(1, e.currentPage - a), i = Math.min(e.totalPages, n + e.maxVisiblePages - 1);
      i - n + 1 < e.maxVisiblePages && (n = Math.max(1, i - e.maxVisiblePages + 1));
      for (let s = n; s <= i; s++)
        t.push(s);
      return t;
    }), c = L(null), V = (t) => {
      t !== e.currentPage && (c.value = t);
    }, p = () => {
      c.value = null;
    }, $ = (t) => t === e.currentPage ? "selected" : t === c.value ? "hover" : "unselected";
    return (t, a) => (r(), b("div", E, [
      u.showFirstLast ? (r(), m(o, {
        key: 0,
        direction: "left",
        disabled: P.value,
        onClick: a[0] || (a[0] = (n) => l(1))
      }, null, 8, ["disabled"])) : h("", !0),
      k(o, {
        direction: "left",
        disabled: P.value,
        onClick: a[1] || (a[1] = (n) => f("left"))
      }, null, 8, ["disabled"]),
      (r(!0), b(y, null, B(M.value, (n) => (r(), m(F, {
        key: n,
        number: n,
        status: $(n),
        onClick: (i) => l(n),
        onMouseenter: (i) => V(n),
        onMouseleave: p
      }, null, 8, ["number", "status", "onClick", "onMouseenter"]))), 128)),
      k(o, {
        direction: "right",
        disabled: v.value,
        onClick: a[2] || (a[2] = (n) => f("right"))
      }, null, 8, ["disabled"]),
      u.showFirstLast ? (r(), m(o, {
        key: 1,
        direction: "right",
        disabled: v.value,
        onClick: a[3] || (a[3] = (n) => l(e.totalPages))
      }, null, 8, ["disabled"])) : h("", !0)
    ]));
  }
});
export {
  S as default
};
